import React from "react";
import app from "nystem";
import { Link, ContentTypeRender } from "nystem-components";

const statusStyles = {
  queued: "border-amber-200 bg-amber-50",
  extracting: "border-blue-200 bg-blue-50",
  complete: "border-green-200 bg-green-50",
  failed: "border-red-200 bg-red-50",
};
const statusLabels = { queued: "Queued", extracting: "Extracting", complete: "Complete", failed: "Failed" };

const ViewLinkResultCard = ({ value: result, path }) => {
  if (!result) return null;
  const provider = app.settings.extraction?.providers?.[result.provider];
  const model = provider?.models?.[result.model]?.label || result.model;
  const created = Number(result._crdate);
  return (
    <Link to={`/result/view/${result._id}`} className={`my-2 block rounded-md border p-3 shadow-sm ${statusStyles[result.status] || "border-gray-200 bg-gray-50"}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="min-w-0 flex-grow font-semibold">{result.name || "Extraction result"}</span>
        <span className="text-sm font-medium">{statusLabels[result.status] || "Unknown status"}</span>
        {result.status === "extracting" && <span className="text-sm">{result.progress || 0}%</span>}
      </div>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600">
        <span>Created: {created && Number.isFinite(created) ? <ContentTypeRender path={path} items={[{ type: "date", id: "_crdate", format: "view", dateFormat: "dateTimeLong", renderAs: "span" }]} /> : "Unknown"}</span>
        <span>Model: {model ? `${provider?.label || result.provider || ""} · ${model}` : "Unknown"}</span>
      </div>
      <div className="mt-1 break-words text-sm">{result.sourceFilename}</div>
      <div className="text-xs text-gray-600">{result.reviewStatus}</div>
    </Link>
  );
};

export default ViewLinkResultCard;
